<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">Toxicity for "{{ data.senderIdText }}"</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog__content">
    @if (dataSource$ | async; as dataSource) {
      @if (!isFetching) {
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let element">{{ element.toxicityTypeDesc }}</td>
          </ng-container>

          <ng-container matColumnDef="rate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Rate</th>
            <td mat-cell *matCellDef="let element">{{ element.toxicityRate.toFixed(2) }}%</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr *matNoDataRow>
            <td colspan="2">Toxicity list is empty</td>
          </tr>
        </table>
      }
    }
    <div class="dialog__spinner">
      <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="handleClose()">Close</button>
  </mat-dialog-actions>
</div>
